import Layout from '../../internal/Layout.vue'
import UnidadesPage from './unidades/unidade.vue'

const UnidadesRoutes = {
  component: Layout,
  children: [
    {
      name: 'unidade',
      path: '/',
      component: UnidadesPage,
      meta: {
        requiresAuth: true,
        requiresMaster: true,
        requiresAdmin: true,
        requiresSupervisor: true,
      },
    },
  ],
}

export default UnidadesRoutes
